export interface ISite {
  id: number;
  name: string;
  accountId: number;
  siteIsActive: boolean;
}

export class SiteModel implements ISite {
  id: number;
  name: string;
  accountId: number;
  siteIsActive: boolean;

  constructor(data: ISite) {
    this.id = data.id ?? null;
    this.name = data.name ?? '';
    this.accountId = data.accountId ?? null;
    this.siteIsActive = data.siteIsActive ?? true;
  }
}
